import type { IconData } from '@stacksjs/iconify-core'

export const arrowheadsRightChevronCircle: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0M4.5 11.5H9L12.5 8L9 4.5H4.5L8 8z\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default arrowheadsRightChevronCircle
